import React, { useEffect, useState, } from "react";
import toast from 'react-hot-toast';
import Button from "../components/ds/Button";
import Icon from "../components/ds/Icon";
import Tag from "../components/ds/Tag";
import Textfield from "../components/ds/Textfield";
import { userService } from '../container';
import { useGlobalState } from '../state';
import AuthorEditor from "../components/AuthorEditor";

export default function NewPost() {
  const { user, setUser } = useGlobalState();
  const [profile, setProfile] = useState(user.profile);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user.profile) {
      setProfile(user.profile);
    }
  }, [user.profile]);

  const updateProfile = async () => {
    setLoading(true);

    try {
      await userService.updateProfile(user.id, profile);

      setUser({
        ...user,
        profile,
      });
    } catch (err) {
      console.error(err);
      toast.error('Ocurrió un error al actualizar tu perfil');
    }

    setLoading(false);
  };

  return (
    <>
      <div id="content">
        <div id="profile">
          <div
            className="picture"
            style={{
              backgroundImage: user.picture && `url(${user.picture})`,
            }}
          >
            <input type="file" />
            <Icon icon="camera" />
          </div>

          <div className="container">
            <div className="info">
              <div>
                <h2 className="t-heading-m">{user.name} {user.last_name}</h2>

                <p className="t-body-s">{user.email}</p>

                <Tag type="secondary" label={user.role} />
              </div>

              <div>

                <AuthorEditor
                  user={user}
                  onChange={(bio) => {
                    setProfile({ ...profile, bio: JSON.stringify(bio) })
                  }}
                />

                <div>
                  <Textfield
                    icon="twitter"
                    placeholder="@"
                    value={profile.social_media.twitter}
                    onChange={(e) => setProfile({
                      ...profile,
                      social_media: {
                        ...profile.social_media,
                        twitter: e.target.value,
                      },
                    })}
                  />
                  <Textfield
                    icon="instagram"
                    placeholder="@"
                    value={profile.social_media.instagram}
                    onChange={(e) => setProfile({
                      ...profile,
                      social_media: {
                        ...profile.social_media,
                        instagram: e.target.value,
                      },
                    })}
                  />
                  <Textfield
                    icon="facebook"
                    placeholder="@"
                    value={profile.social_media.facebook}
                    onChange={(e) => setProfile({
                      ...profile,
                      social_media: {
                        ...profile.social_media,
                        facebook: e.target.value,
                      },
                    })}
                  />
                </div>
              </div>
            </div>
            <Button
              label="Actualizar"
              onclick={updateProfile}
              loading={loading}
            />
          </div>
        </div>
      </div>
    </>
  )
}
